/* eslint-disable no-console */
export class WebWorker {
    static worker: Worker;
    static apiWorker: any = {
      // doing for web component
      // will replace once we find the solution to use web worker in web component
      postMessage: (data: any) => {
        const { endpoint, config, payload, nodeId } = data;
        fetch(endpoint, config)
          .then(async res => {
            const apiData = await res.json();
            return {
              status: res.status,
              ...(apiData ?? {}),
            };
          })
          .then(apiData => {
            WebWorker.worker?.onmessage?.({
              data: {
                nodeId,
                ...JSON.parse(
                  JSON.stringify({ ...apiData, ...payload })
                ),
              },
            } as any);
          })
          .catch(err => {
            WebWorker.worker?.onmessage?.({
              data: { nodeId, ...JSON.parse(JSON.stringify({ err })) },
            } as any);
          });
      },
    }
  
    static init() {
      WebWorker.worker = WebWorker.apiWorker as any;

      /* ABSOLUTE, NOT './worker.js'. A relative URL resolves against the
         CURRENT ROUTE, so the file was only ever found from a one-segment
         path. From any nested route the browser asked for, say,
         /transaction-monitoring/worker.js, and the SPA fallback answered it
         with index.html. Affects every nested route in the app -- the four
         under /transaction-monitoring, plus /profile/confirm, /funds/:id,
         /files-documents/:id and /evault/:id.

         Matches utils/pdf-compress.ts, which already resolves its own worker
         this way. */
      const url = `${process.env.PUBLIC_URL ?? ''}/worker.js`;
      fetch(url)
        .then(response => {
          /* `response.ok` ALONE IS NOT ENOUGH, and that is why this failed
             silently. The dev server and the production SPA host both answer
             an unknown path with index.html and HTTP **200**, so `ok` was true
             and a Worker was constructed over HTML. It then died inside the
             worker with "Uncaught SyntaxError: Unexpected token '<'" -- a
             message that names no route and no cause, in a console nobody
             reads. Check what came back, not just that something did. */
          const type = response.headers.get('content-type') ?? '';
          const isScript = /javascript|ecmascript/i.test(type);
          if (response.ok && isScript) {
            // The file exists, try to create the worker
            try {
              const worker = new Worker(url);
              worker.onerror = function(error) {
                WebWorker.worker = WebWorker.apiWorker;
                console.error('Worker error:', error.message);
              };
              /* NOTE: onerror is asynchronous, so a script that fails to parse
                 still yields a Worker object here and is adopted for a short
                 window before onerror swaps the fallback back in. Any
                 postMessage in that window is lost silently. The content-type
                 check above removes the cause we actually hit (HTML from the
                 SPA fallback); closing the window in general would mean
                 handshaking with the worker before adopting it, which is a
                 bigger change than this fix warrants. */
              WebWorker.worker = worker;
              // Worker created successfully, you can send a message or do other actions here
            } catch (error) {
              WebWorker.worker = WebWorker.apiWorker;
              console.error('Error creating worker:', error);
            }
          } else {
            WebWorker.worker = WebWorker.apiWorker;
            console.error('Worker script not found:', url);
          }
        })
        .catch(error => {
          console.error('Error fetching worker script:', error);
          WebWorker.worker = WebWorker.apiWorker;
        });
    }
  }
  
  WebWorker.init();